import { SessionEvent, StartSessionEventResponse } from "@veris-health/communication-ms/lib/v1";
import { activityTrackingApiV1 } from "../../../../api";

export const addSessionEventActivity = async (
  sessionEvent: SessionEvent,
): Promise<StartSessionEventResponse> => {
  const response = await activityTrackingApiV1.activityTracking(sessionEvent);
  return response.data;
};
